import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function AdminCalendar() {
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get(`/admin/slots?date=${date}`).then((r) => setData(r.data)).catch(() => {});
  }, [date]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (experience, slot, blocked) => {
    try {
      await api.post("/admin/slots/toggle", { experience, date, slot, blocked });
      load();
    } catch {
      toast.error("Erreur lors de la mise à jour du créneau");
    }
  };

  const sections = [
    { key: "boho", title: "The Boho Picnic", note: "Réservations multiples autorisées par créneau" },
    { key: "floating", title: "Floating Picnic", note: "1 réservation par créneau · 2 invités max" },
  ];

  return (
    <div data-testid="admin-calendar">
      <h1 className="font-serif text-3xl sm:text-4xl text-ink">Calendrier & créneaux</h1>
      <div className="w-16 h-px bg-gold mt-4" />
      <div className="mt-8">
        <label className="block text-xs uppercase tracking-[0.15em] text-earth mb-2">Date</label>
        <input data-testid="calendar-date" type="date" className="input-elegant !w-auto" value={date}
          onChange={(e) => setDate(e.target.value)} />
      </div>
      {data && sections.map((s) => (
        <div key={s.key} className="mt-10">
          <h2 className="font-serif text-2xl text-ink">{s.title}</h2>
          <p className="text-xs text-earth mt-1">{s.note}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
            {data.experiences[s.key].map((slot) => (
              <div key={slot.slot} data-testid={`slot-card-${s.key}-${slot.slot}`}
                className={`border rounded-2xl p-5 ${slot.blocked ? "border-burgundy/30 bg-burgundy/5" : "border-champagne bg-ivory"}`}>
                <div className="flex items-center justify-between">
                  <span className="font-serif text-xl text-ink">{slot.slot.replace("-", " – ")}</span>
                  <button data-testid={`toggle-${s.key}-${slot.slot}`} onClick={() => toggle(s.key, slot.slot, !slot.blocked)}
                    className={`text-xs uppercase tracking-wide px-4 py-2 rounded-full border transition-colors ${slot.blocked ? "border-burgundy text-burgundy hover:bg-burgundy hover:text-ivory" : "border-olive text-olive-deep hover:bg-olive hover:text-ivory"}`}>
                    {slot.blocked ? "Rouvrir" : "Fermer"}
                  </button>
                </div>
                <div className="mt-3 text-sm">
                  {slot.blocked && <p className="text-burgundy text-xs uppercase tracking-wide">Créneau fermé</p>}
                  {slot.bookings.length === 0 && !slot.blocked && <p className="text-earth/60 text-xs">Aucune réservation</p>}
                  {slot.bookings.map((b) => (
                    <p key={b.id} className="text-earth text-xs mt-1">
                      {b.customer.name} — {b.guests} invité(s) · {b.payment_status === "paid" ? "payé" : "en attente"}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
